import { Table, TableProps } from '@sbercloud/uikit-product-site-table';
import { useMemo } from 'react';

type ArticleTableProps = {
  rows: string[][];
};

export function ArticleTable(props: ArticleTableProps) {
  const { rows } = props;

  const tableRows: TableProps['rows'] = useMemo(
    () =>
      rows.map((row, index) => {
        const cellInHeader = index === 0;

        if (cellInHeader) {
          return row.map((cell) => ({
            content: cell,
          }));
        }

        return row.map((text) => {
          return {
            content: text,
          };
        });
      }),
    [rows],
  );

  return <Table rows={tableRows} withHeader data-test-id="article-table" />;
}
